module.exports = __webpack_public_path__ + "static/media/snapsendsolve@2x.c1ae2bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/outware/snapsendsolve@2x.png
// module id = 63
// module chunks = 0